import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import { formatCurrency } from 'utils';
import Modal from 'common/modal';
import Button from 'common/button';

const BackpledgePrompt = ({
    show,
    eventCount,
    eventNameSingular,
    eventNamePlural,
    result,
    metricNameSingular,
    metricNamePlural,
    amount,
    onAccept,
    onDecline,
    onClose,
}) => {
    const eventTerm = eventCount === 1 ? eventNameSingular : eventNamePlural;
    const metricTerm = result === 1 ? metricNameSingular : metricNamePlural;
    const formattedMetric = numeral(result).format('0,0[.]0');
    const formattedAmount = formatCurrency(amount);

    return (
        <Modal close={onClose} isOpen={show}>
            <div className="p-10 md:p-14 text-center">
                <h1 className="text-21 text-gray-70 leading-tight">
                    It looks like {eventCount} {eventTerm} already happened!
                </h1>
                <p className="text-16 text-gray-70 leading-relaxed mt-4">
                    Would you like to extend your pledge to include the previous {eventCount}{' '}
                    {eventTerm}?
                </p>
                <p className="text-16 text-gray-40 leading-relaxed mt-4">
                    {formattedMetric} {metricTerm} - {formattedAmount}
                </p>

                <div className="-mb-4 mt-8">
                    <Button
                        color="green"
                        size="md"
                        className="text-16 uppercase font-bold tracking-wide block w-full"
                        onClick={onAccept}
                        data-testid="accept"
                    >
                        Sure!
                    </Button>
                    <Button
                        size="md"
                        className="text-16 link-gray mt-2"
                        onClick={onDecline}
                        data-testid="decline"
                    >
                        No thanks
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

BackpledgePrompt.propTypes = {
    show: PropTypes.bool.isRequired,
    eventCount: PropTypes.number.isRequired,
    eventNameSingular: PropTypes.string.isRequired,
    eventNamePlural: PropTypes.string.isRequired,
    result: PropTypes.number.isRequired,
    metricNameSingular: PropTypes.string.isRequired,
    metricNamePlural: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    onAccept: PropTypes.func.isRequired,
    onDecline: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default BackpledgePrompt;
